import { useEffect } from 'react'
import { useLocation, useNavigate } from '@tanstack/react-router'

import { useAppNavbar } from '@/shared/hooks/use-app-navbar'
import { useTheme } from '@/shared/hooks/use-theme'
import { AppsflyerEvent, sendAppsflyer } from '@/shared/metrics'
import { Button } from '@/shared/ui'

import { getStoredPaymentMethod } from '@/features/payment-method'

import styles from './driver-recharge-error.module.scss'

import { IllustrationWarningDark, IllustrationWarningLight } from '@/assets'

export const DriverRechargeError = (): React.ReactNode => {
    const { theme } = useTheme()
    const illustration = theme === 'light' ? IllustrationWarningLight : IllustrationWarningDark

    useAppNavbar(' ', null, null)
    const navigate = useNavigate()
    const { state } = useLocation()
    const error = (state as undefined | { error?: string })?.error ?? ''
    const payment_method = getStoredPaymentMethod().id

    useEffect(() => {
        sendAppsflyer(AppsflyerEvent.finance_topup_failed_view, {
            payment_method,
            error_reason: error,
        })
    }, [error, payment_method])

    const handleClick = (): void => {
        sendAppsflyer(AppsflyerEvent.finance_topup_failed_method_click, {})
        navigate({ to: '/driver-recharge', replace: true })
    }

    return (
        <div className={styles['driver-recharge-error__content']}>
            <img
                alt='Illustration Warning'
                className={styles['driver-recharge-error__illustration']}
                src={illustration}
            />
            <h1
                className={styles['driver-recharge-error__title']}
                data-test-id='driver-recharge-error-title'
            >
                Что-то пошло не так
            </h1>
            <p className={styles['driver-recharge-error__description']}>
                Попробуйте выбрать другой способ
                <br />
                пополнения и повторите попытку
            </p>
            <Button
                className={styles['driver-recharge-error__button']}
                size='large'
                variant='primary'
                onClick={handleClick}
            >
                Выбрать другой способ
            </Button>
        </div>
    )
}
